import React, { Component } from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import Home from 'react-icons/lib/fa/home';

import Tulsa1 from './../assets/img/projects/tulsa-1.jpg';
import Tulsa2 from './../assets/img/projects/tulsa-2.jpg';
import Tulsa3 from './../assets/img/projects/tulsa-3.jpg';

let simpleParallax;

class MCF23 extends Component {
  componentDidMount() {
    const hamburger = document.querySelector('.nav-hamburger');
    hamburger.style.display = 'none';

    simpleParallax = require('simple-parallax-js');
    const tulsaImages = document.querySelectorAll('.tulsa-img');
    new simpleParallax(tulsaImages, { scale: 1.1 });
  }

  componentWillUnmount() {
    const hamburger = document.querySelector('.nav-hamburger');
    hamburger.style.display = 'block';
  }

  render() {
    return (
      <div className="project-page">
        <Helmet
            title="MCF23 | Maslow Development Inc."
            meta={[
              { name: 'description', content: 'We co-design & develop real estate and community ecosystems.' },
              { name: 'keywords', content: 'maslow, maslow development, maslow development inc, real estate, community development, community developer, community planner, real estate development, real estate developer, real estate design, real estate designer' }
            ]}
        />

        <Link to='/#highlighted-projects' className='project-page-link-home'>
            ←<Home className='link-home-icon' />
        </Link>

        <h6 className='project-page-label'>Highlighted Project</h6>
        <h1 className='project-page-title'>MCF23</h1>
        <h5 className='project-page-blurb'>Reimagining Black Wall Street in North Tulsa</h5>

        <section className='project-page-hero'>
            <img src={Tulsa1} className='project-page-hero-image tulsa-img' alt='Clayborn Temple' />

            <div className='project-page-details'>
                <p className='project-page-detail'>
                    <strong>Challenge</strong>
                    How might we reinvest in and empower a community that was once a hub for economic opportunity and vitality?
                </p>
                <p className='project-page-detail'>
                    <strong>Solution</strong>
                    A 23-acre, mixed-use community with an acute focus on business & entrepreneurship to create an ecosystem around economic sustainability.
                </p>
                <p className='project-page-detail'>
                    <strong>Team</strong>
                    Maslow Development Inc. & Met Cares Foundation
                </p>
            </div>
        </section>

        <img src={Tulsa2} className='project-page-full-image tulsa-img' alt='Clayborn Temple' />

        <h3 className='project-page-quote'>
            MCF is committed to transforming the academic and social outcomes for families living in North Tulsa by operating great schools, engaging the community, and ensuring that robust economic development can thrive, all in an effort to return North Tulsa to the greatness it achieved in the early 1900’s when it was the financial and business center of the United States and Black excellence was synonymous with that success.
            <span>— Ray Owens, Chairman, Met Cares Foundation</span>
        </h3>

        <img src={Tulsa3} className='project-page-full-image tulsa-img' alt='Clayborn Temple' />
      </div>
    );
  }
}

export default MCF23;



// WEBPACK FOOTER //
// ./src/pages/mcf23.js